import { render, staticRenderFns } from "./ClosedByAdjusterDate.vue?vue&type=template&id=bcbc5468"
import script from "./ClosedByAdjusterDate.vue?vue&type=script&lang=js"
export * from "./ClosedByAdjusterDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports